import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { finalize, tap } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Observable } from 'rxjs';
import { DialogCallbacks } from '../dialog-common.interface';

export interface AutoRenewConfirmationDialogData extends DialogCallbacks {
  confirm$: Observable<any>;
  autoRenew: boolean;
  title: string;
  description: string;
  confirm: string;
  cancel: string;
}

@Component({
  template: `
    <pp-shell-dialog [title]="data.title | translate">
      <div mat-dialog-content>
        <p>{{(data.description | translate)[data.autoRenew ? "on" : "off"]}}</p>
      </div>
      <div mat-dialog-actions class="actions" align="end">
        <button [disabled]="isLoading" mat-flat-button mat-dialog-close>{{data.cancel | translate}}</button>
        <button (click)="onConfirm()" class="loading-btn" mat-flat-button color="primary">
          {{data.confirm | translate}}
          <mat-spinner *ngIf="isLoading" diameter="18" color="accent"></mat-spinner>
        </button>
      </div>
    </pp-shell-dialog>
  `,
  styleUrls: ['./auto-renew-confirmation.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoRenewConfirmationDialogComponent {
  public isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<AutoRenewConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AutoRenewConfirmationDialogData
  ) {}

  public onConfirm() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.data.confirm$.pipe(
        tap(() => this.isLoading = false),
        finalize(() => this.dialogRef.close())
      ).subscribe(
        (res) => this.data.onSuccess && this.data.onSuccess(res),
        (err) => this.data.onError && this.data.onError(err),
      );
    }
  }

}
